// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>6</span>&nbsp;&nbsp;I stretch out my hands to you;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;my soul gasps for you like a thirsty land.<br> </p> </div></div>";
// Exports
module.exports = code;